(function(){
"use strict";

/* ---------------- helpers ---------------- */
var clamp=function(v,lo,hi){return Math.min(hi,Math.max(lo,v))};
var smoothstep=function(p,e0,e1){var t=clamp((p-e0)/(e1-e0),0,1);return t*t*(3-2*t)};
function rng(seed){var s=seed>>>0;return function(){s=(s*1664525+1013904223)>>>0;return s/4294967296}}

/* ---------------- split text once ---------------- */
var bands=[].slice.call(document.querySelectorAll('.band'));
var seed=7;
[].slice.call(document.querySelectorAll('[data-text]')).forEach(function(el){
  var text=el.getAttribute('data-text');
  var mode=el.closest('.band').getAttribute('data-entrance');
  var spread=parseFloat(el.closest('.band').getAttribute('data-spread')||'.5');
  var sr=document.createElement('span');sr.className='sr';sr.textContent=text;
  el.textContent='';el.appendChild(sr);

  if(mode==='blur'){
    var wrap=document.createElement('span');wrap.className='blurwrap';wrap.setAttribute('aria-hidden','true');
    var soft=document.createElement('span');soft.className='soft';soft.textContent=text;
    var sharp=document.createElement('span');sharp.className='sharp';sharp.textContent=text;
    wrap.appendChild(soft);wrap.appendChild(sharp);el.appendChild(wrap);
    return;
  }

  var vis=document.createElement('span');vis.setAttribute('aria-hidden','true');
  var words=text.split(' ');
  var r=rng(seed+=13);
  var totalChars=text.replace(/ /g,'').length,ci=0;
  words.forEach(function(word,wi){
    var w=document.createElement('span');w.className='w';
    if(mode==='drift'||mode==='rise'){
      w.style.setProperty('--th',(wi/Math.max(1,words.length))*0.55);
      w.textContent=word;
    }else{
      word.split('').forEach(function(ch){
        var c=document.createElement('span');c.className='c';c.textContent=ch;
        var ordered=(ci/Math.max(1,totalChars))*spread;
        c.style.setProperty('--th',(ordered+r()*0.06).toFixed(3));
        c.style.setProperty('--jx',((r()-.5)*54).toFixed(1)+'px');
        c.style.setProperty('--jy',((r()-.5)*46).toFixed(1)+'px');
        c.style.setProperty('--jr',((r()-.5)*22).toFixed(1)+'deg');
        w.appendChild(c);ci++;
      });
    }
    vis.appendChild(w);
    if(wi<words.length-1)vis.appendChild(document.createTextNode(' '));
  });
  el.appendChild(vis);
});

/* ---------------- hero drive ---------------- */
var hero=document.querySelector('.hero');
var stage=document.getElementById('stage');
var video=document.getElementById('hero');
var ring=document.getElementById('ring');
var posterLayer=document.querySelector('.stage .poster');
var VIDEO_URL=video.getAttribute('data-src');
var VIDEO_BYTES=2992713;

var target=0,shown=0,rafId=null,lastTick=0,heroOnScreen=true;
var seekBusy=false,pendingTime=null;
var started=false,scrubOn=false,initDone=false;

function heroProgress(){
  if(!hero)return 0;
  var r=hero.getBoundingClientRect();
  var range=hero.offsetHeight-window.innerHeight;
  if(range<=0)return 0;
  return clamp(-r.top/range,0,1);
}

function requestSeek(t){
  if(!video.duration)return;
  if(seekBusy){pendingTime=t;return}
  seekBusy=true;video.currentTime=t;
}
video.addEventListener('seeked',function(){
  seekBusy=false;
  if(pendingTime!==null){var t=pendingTime;pendingTime=null;requestSeek(t)}
});
video.addEventListener('error',function(){seekBusy=false;pendingTime=null;failVideo()});

function tick(now){
  var dt=Math.min(100,now-(lastTick||now));lastTick=now;
  var k=0.16;
  shown+=(target-shown)*(1-Math.pow(1-k,dt/16.667));
  if(Math.abs(target-shown)<0.0005){shown=target;rafId=null;lastTick=0}
  else{rafId=requestAnimationFrame(tick)}
  if(video.duration)requestSeek(shown*video.duration);
  updateBands(shown);
}
function onScroll(){
  target=heroProgress();
  if(rafId===null&&heroOnScreen)rafId=requestAnimationFrame(tick);
}

/* caption bands, delta gated */
var loadK=0,loadStart=0,cueEl=document.querySelector('.cue'),lastCue=-1;
function updateBands(p){
  var cue=clamp(1-p*7,0,1);
  if(cueEl&&Math.abs(cue-lastCue)>0.02){lastCue=cue;cueEl.style.setProperty('--cueop',cue.toFixed(2))}
  for(var i=0;i<bands.length;i++){
    var b=bands[i];
    var a=parseFloat(b.getAttribute('data-a')),z=parseFloat(b.getAttribute('data-b'));
    var f=Math.min(0.02,(z-a)/3);
    var inOp=(i===0)?1:smoothstep(p,a,a+f);
    var outOp=(i===bands.length-1)?1:(1-smoothstep(p,z-f,z));
    var op=inOp*outOp;
    if(Math.abs(op-(b._op===undefined?-1:b._op))>0.004){b._op=op;b.style.opacity=op.toFixed(3)}
    var ramp=parseFloat(b.getAttribute('data-ramp'))||Math.min(0.025,(z-a)*0.35);
    var kk=clamp((p-a)/ramp,0,1);
    if(b.getAttribute('data-first'))kk=Math.max(kk,loadK);
    if(Math.abs(kk-(b._k===undefined?-1:b._k))>0.008){
      b._k=kk;b.style.setProperty('--k',kk.toFixed(3));
      if(b.classList.contains('b4')){
        b.style.setProperty('--ks',clamp((kk-0.5)*3,0,1).toFixed(3));
        b.style.setProperty('--kb',clamp((kk-0.72)*4,0,1).toFixed(3));
      }
    }
  }
}
function loadRamp(ts){
  if(!loadStart)loadStart=ts;
  loadK=clamp((ts-loadStart)/1100,0,1);
  updateBands(shown);
  if(loadK<1)requestAnimationFrame(loadRamp);
}

/* video load */
function failVideo(){
  if(ring&&ring.parentNode){ring.style.display='none'}
  stage.classList.add('video-failed');
}
function startBlobFetch(){
  if(started)return;started=true;
  loadHeroBlob().catch(failVideo);
}
function loadHeroBlob(){
  var ctrl=new AbortController();
  var watchdog=setTimeout(function(){ctrl.abort()},20000);
  return fetch(VIDEO_URL,{signal:ctrl.signal}).then(function(res){
    if(!res.ok||!res.body)throw new Error('no body');
    var total=Number(res.headers.get('Content-Length'))||VIDEO_BYTES;
    var reader=res.body.getReader(),chunks=[],got=0,lastRing=0;
    function pump(){
      return reader.read().then(function(r){
        if(r.done)return;
        clearTimeout(watchdog);
        watchdog=setTimeout(function(){ctrl.abort()},20000);
        chunks.push(r.value);got+=r.value.length;
        var frac=Math.min(1,got/total),now=performance.now();
        if(now-lastRing>100||frac===1){lastRing=now;ring.style.setProperty('--ld',Math.round(126*(1-frac)))}
        return pump();
      });
    }
    return pump().then(function(){
      clearTimeout(watchdog);
      ring.style.setProperty('--ld',0);
      ring.style.opacity=0;
      video.src=URL.createObjectURL(new Blob(chunks));
      video.load();
      video.addEventListener('canplay',function(){
        requestSeek(heroProgress()*video.duration);
        stage.classList.add('video-ready');
      },{once:true});
    });
  });
}
function initHeroOnce(){
  if(initDone)return;initDone=true;
  var POSTER=video.getAttribute('data-poster');
  posterLayer.style.backgroundImage="url('"+POSTER+"')";
  var img=new Image();
  img.onload=startBlobFetch;img.onerror=startBlobFetch;
  img.src=POSTER;
  setTimeout(startBlobFetch,4000);
  requestAnimationFrame(loadRamp);
  if('IntersectionObserver' in window){
    new IntersectionObserver(function(es){heroOnScreen=es[0].isIntersecting;if(heroOnScreen)onScroll()},{threshold:0})
      .observe(hero);
  }
}

/* the five gates, matched to the CSS character for character */
var GATES=[
  '(max-width: 720px)',
  '(orientation: portrait) and (max-width: 1024px)',
  '(orientation: portrait) and (pointer: coarse)',
  '(orientation: landscape) and (pointer: coarse) and (max-height: 560px)',
  '(prefers-reduced-motion: reduce)'
];
function enableScrub(){
  if(scrubOn)return;scrubOn=true;
  initHeroOnce();
  window.addEventListener('scroll',onScroll,{passive:true});
  bands.forEach(function(b){b._op=-1;b._k=-1});
  unpinFinalStates();
  updateBands(heroProgress());
  onScroll();
}
function disableScrub(){
  if(!scrubOn)return;scrubOn=false;
  window.removeEventListener('scroll',onScroll);
  if(rafId!==null){cancelAnimationFrame(rafId);rafId=null}
}
function applyHeroMode(){
  var gated=GATES.some(function(q){return matchMedia(q).matches});
  if(gated)disableScrub();else enableScrub();
}
var MQLS=GATES.map(function(q){return matchMedia(q)});
MQLS.forEach(function(m){
  if(m.addEventListener)m.addEventListener('change',applyHeroMode);
  else if(m.addListener)m.addListener(applyHeroMode);
});

/* static hero background image, only on the gated path */
(function(){
  var sh=document.getElementById('statichero');
  if(sh)sh.style.backgroundImage="url('"+sh.getAttribute('data-bg')+"')";
})();

/* ---------------- scroll entrances ---------------- */
var io=null;
if('IntersectionObserver' in window){
  io=new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(!e.isIntersecting)return;
      e.target.classList.add('in');
      if(e.target.classList.contains('stagger')){
        setTimeout(function(){e.target.classList.add('done')},1300);
      }
      io.unobserve(e.target);
    });
  },{threshold:.16,rootMargin:'0px 0px -8% 0px'});
  [].slice.call(document.querySelectorAll('.rise-in,.stagger,.divider')).forEach(function(el){io.observe(el)});
}else{
  [].slice.call(document.querySelectorAll('.rise-in,.stagger,.divider')).forEach(function(el){el.classList.add('in')});
}

/* ---------------- the porch light switch ---------------- */
var plate=document.getElementById('plate');
var scene=document.getElementById('scene');
var holding=false,lit=0,switchRaf=null,lastSwitch=0;

function setLit(v){
  lit=v;
  scene.style.setProperty('--lit',v.toFixed(3));
  plate.style.setProperty('--lit',v.toFixed(3));
  document.querySelector('.verdictline').style.setProperty('--lit',v.toFixed(3));
}
function switchTick(now){
  var dt=Math.min(64,now-(lastSwitch||now));lastSwitch=now;
  var dir=holding?1:-1;
  var next=clamp(lit+dir*(dt/900),0,1);
  setLit(next);
  if((holding&&next<1)||(!holding&&next>0)){switchRaf=requestAnimationFrame(switchTick)}
  else{switchRaf=null;lastSwitch=0}
}
function startHold(e){
  if(e&&e.cancelable)e.preventDefault();
  holding=true;
  if(switchRaf===null)switchRaf=requestAnimationFrame(switchTick);
}
function endHold(){
  holding=false;
  if(switchRaf===null&&lit>0)switchRaf=requestAnimationFrame(switchTick);
}
if(plate){
  plate.addEventListener('pointerdown',startHold);
  window.addEventListener('pointerup',endHold);
  window.addEventListener('pointercancel',endHold);
  plate.addEventListener('keydown',function(e){
    if(e.key===' '||e.key==='Enter'){e.preventDefault();startHold()}
  });
  plate.addEventListener('keyup',function(e){
    if(e.key===' '||e.key==='Enter')endHold();
  });
}

/* ---------------- the countdown ---------------- */
/* CONFIRM WITH SUPPLIER: this is the cutoff used in the deadline section and the FAQ. */
var CUTOFF=new Date('2026-10-03T23:59:59');
var cdEls={d:document.getElementById('cd'),h:document.getElementById('ch'),m:document.getElementById('cm')};
var lastCd='';
function pad(n){return n<10?'0'+n:''+n}
function tickCount(){
  if(!cdEls.d)return;
  var ms=CUTOFF-new Date();
  if(ms<0)ms=0;
  var d=Math.floor(ms/86400000),h=Math.floor(ms/3600000)%24,m=Math.floor(ms/60000)%60;
  var s=d+'|'+h+'|'+m;
  if(s===lastCd)return;
  lastCd=s;
  cdEls.d.textContent=pad(d);cdEls.h.textContent=pad(h);cdEls.m.textContent=pad(m);
}
tickCount();setInterval(tickCount,20000);

/* ---------------- reduced motion, both directions ---------------- */
function pinToFinalStates(){
  [].slice.call(document.querySelectorAll('.rise-in,.stagger,.divider')).forEach(function(el){
    el.classList.add('in');el.classList.add('done');
  });
  setLit(1);
  holding=false;
  if(switchRaf!==null){cancelAnimationFrame(switchRaf);switchRaf=null}
}
function unpinFinalStates(){
  var rm=matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(rm)return;
  if(lit===1&&!holding)setLit(0);
}
var rmq=matchMedia('(prefers-reduced-motion: reduce)');
function onRM(e){
  if(e.matches)pinToFinalStates();
  else applyHeroMode();
}
if(rmq.addEventListener)rmq.addEventListener('change',onRM);
else if(rmq.addListener)rmq.addListener(onRM);
if(rmq.matches)pinToFinalStates();

/* ---------------- pause when the tab is hidden ---------------- */
document.addEventListener('visibilitychange',function(){
  document.body.classList.toggle('paused',document.hidden);
});

/* go */
applyHeroMode();
})();
